import React, { useState } from "react";

import { Container, Row, Col } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import swal from "sweetalert";

import CustomGreenButton from "../../../../components/shared/custom-green-button";
import { GENERAL_URL_API } from "../../../../shared/urls";

import AlcanceSelector from "../recomendacion-paquetes/alcance-selector";
import PaqueteSelector from "./paquete-selector";

const API_GENERAR = `${GENERAL_URL_API}/recomendacion/generarCatalogoRenovacion.php`;

const ALCANCE_INICIAL = { superInstituto: "", institutos: [], clientes: [] };

const CatalogoRenovacion = () => {
  const [alcance, setAlcance] = useState(ALCANCE_INICIAL);
  const [paquetes, setPaquetes] = useState([]);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [loading, setLoading] = useState(false);
  const [resumen, setResumen] = useState(null);
  const [paises, setPaises] = useState([]);

  const buildConfig = () => ({
    alcance,
    paquetes,
    fechaInicio: fechaInicio.trim(),
    fechaFin: fechaFin.trim(),
  });

  const validar = async () => {
    if (!alcance.superInstituto) {
      await swal({
        title: "Error",
        text: "Selecciona un Super Instituto",
        icon: "error",
      });
      return false;
    }
    if (!paquetes.length) {
      await swal({
        title: "Error",
        text: "Selecciona al menos un paquete base",
        icon: "error",
      });
      return false;
    }
    return true;
  };

  const handleGenerar = async () => {
    if (!(await validar())) return;

    setLoading(true);
    setResumen(null);
    setPaises([]);

    try {
      const fd = new FormData();
      fd.append("config", JSON.stringify(buildConfig()));
      fd.append("descargar", 1);

      const res = await fetch(API_GENERAR, {
        method: "POST",
        credentials: "include",
        body: fd,
      });

      const contentType = res.headers.get("content-type") || "";
      if (!res.ok) {
        const errJson = contentType.includes("application/json")
          ? await res.json()
          : null;
        throw new Error(errJson?.info || `Error ${res.status}`);
      }
      if (contentType.includes("application/json")) {
        const err = await res.json();
        throw new Error(err?.info || "No se pudo generar el archivo");
      }

      const totalHeader = res.headers.get("X-Catalogo-Total");
      const enPaqueteHeader = res.headers.get("X-Catalogo-En-Paquete");
      const paisesHeader = res.headers.get("X-Catalogo-Paises") || "";

      const total =
        totalHeader !== null ? parseInt(totalHeader, 10) : null;
      const enPaquete =
        enPaqueteHeader !== null ? parseInt(enPaqueteHeader, 10) : null;
      const paisesResumen = paisesHeader
        ? paisesHeader.split(",").filter(Boolean)
        : [];

      if (total !== null && enPaquete !== null) {
        setResumen({ total, enPaquete });
        setPaises(paisesResumen);
      }

      const blob = await res.blob();
      let filename = `catalogo-renovacion-${new Date().toISOString().split("T")[0]}.xlsx`;
      const disposition = res.headers.get("content-disposition") || "";
      const match = disposition.match(
        /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i
      );
      const extracted = match ? match[1] || match[2] : null;
      if (extracted) {
        try {
          filename = decodeURIComponent(extracted);
        } catch (_) {
          filename = extracted;
        }
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      await swal({
        title: "Catálogo generado",
        text:
          total !== null && enPaquete !== null
            ? `${total} libros (${enPaquete} en paquete)`
            : "El archivo Excel se descargó correctamente. Revisa la hoja Parámetros para el resumen.",
        icon: "success",
      });
    } catch (e) {
      await swal({
        title: "Error",
        text: e.message || "No se pudo generar el catálogo",
        icon: "error",
      });
    }

    setLoading(false);
  };

  const rangoFechasTexto = () => {
    if (fechaInicio && fechaFin) return `${fechaInicio} a ${fechaFin}`;
    if (fechaInicio) return `desde ${fechaInicio}`;
    if (fechaFin) return `hasta ${fechaFin}`;
    return "Histórico completo";
  };

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <LibraryBooksIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">
          Catálogo de renovación (Super Instituto)
        </div>
      </div>

      <Container fluid>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <AlcanceSelector alcance={alcance} onChange={setAlcance} />
            <PaqueteSelector
              alcance={alcance}
              paquetes={paquetes}
              onChange={setPaquetes}
              disabled={loading}
            />

            <label className="admin-label-text mt-4 d-block">
              Estadísticas de lectura (opcional):
            </label>
            <div className="d-flex flex-wrap align-items-center">
              <TextField
                label="Desde"
                type="date"
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
                variant="outlined"
                size="small"
                InputLabelProps={{ shrink: true }}
                style={{
                  width: "180px",
                  fontFamily: "'Noto Sans JP', sans-serif",
                }}
              />
              <span className="mx-2 admin-muted-text-small">—</span>
              <TextField
                label="Hasta"
                type="date"
                value={fechaFin}
                onChange={(e) => setFechaFin(e.target.value)}
                variant="outlined"
                size="small"
                InputLabelProps={{ shrink: true }}
                style={{
                  width: "180px",
                  fontFamily: "'Noto Sans JP', sans-serif",
                }}
              />
            </div>
            <div className="admin-muted-text-small mt-2">
              Las fechas filtran únicamente las columnas de lecturas; el catálogo
              incluye todos los libros disponibles en el territorio.
            </div>

            <CustomGreenButton
              variant="contained"
              className="mt-4"
              onClick={handleGenerar}
              disabled={loading}
            >
              {loading ? "Generando..." : "Descargar Excel"}
            </CustomGreenButton>
          </Col>
        </Row>

        {resumen && (
          <Row>
            <Col xs={12} className="content-white-box px-4 py-4 mt-3">
              <div className="admin-main-title-dark-gray">Última generación</div>
              <div className="admin-muted-text-small mt-2">
                Total libros: {resumen.total ?? 0} · En paquete (amarillo):{" "}
                {resumen.enPaquete ?? 0}
                {paises.length > 0 && ` · Territorio: ${paises.join(", ")}`}
                {` · Lecturas: ${rangoFechasTexto()}`}
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </>
  );
};

export default CatalogoRenovacion;
